import { registerComponent } from '../registry';
import PaymentComponent from './Payment.component';
import PaymentEditor from './Payment.editor';
import PaymentProperties from './Payment.properties';

// 레지스트리에 컴포넌트 등록
registerComponent({
  type: 'PAYMENT', // 타입 상수
  component: PaymentComponent,
  editorComponent: PaymentEditor,
  properties: PaymentProperties,
  defaultProps: {
    // 기본 속성 설정
    componentProps: {
      title: '결제하기',
      emptyText: '장바구니가 비어 있습니다.',
      shippingFee: 4000
    },
    style: {
      padding: '40px 0',
      minHeight: '800px',
      marginBottom: '100px',
    }
  },
  category: 'commerce', // 컴포넌트 카테고리
  icon: '💳', // 대표 아이콘
  name: '결제 페이지' // 표시할 이름
});

// 컴포넌트 및 타입 내보내기
export { default as PaymentComponent } from './Payment.component';
export { default as PaymentEditor } from './Payment.editor';
export { default as PaymentProperties } from './Payment.properties';
export * from './Payment.types'; 